import { gql, useQuery } from '@apollo/client';
import { WHITELABEL_CONFIG_FIELDS, WhitelabelConfig } from './useWhitelabelConfigUpsertMutation';

export const GET_WHITELABEL_CONFIG = gql`
  ${WHITELABEL_CONFIG_FIELDS}
  query GetWhitelabelConfig {
    whitelabelConfig {
      ...WhitelabelConfigFields
    }
  }
`;

export interface WhitelabelConfigQueryResult {
  whitelabelConfig: WhitelabelConfig | null;
}

export function useWhitelabelConfigQuery() {
  return useQuery<WhitelabelConfigQueryResult>(GET_WHITELABEL_CONFIG, {
    context: {
      headers: {
        'apollo-require-preflight': true,
      },
    },
  });
}
